import PropTypes from 'prop-types';

const ContactType = PropTypes.shape({
  id: PropTypes.string,
  first_name: PropTypes.string,
  middle_name: PropTypes.string,
  last_name: PropTypes.string
});

export default ContactType;
